import React from "react";
import { StorefrontDescription } from "web/react/components/storefront-description/";
import { StorefrontInfoList } from "web/react/components/storefront-modal/storefront-info-list/";
import { HStack } from "web/react/emo/h-stack";
import { Sticker } from "web/react/emo/sticker";
import { Text } from "web/react/emo/text";
import { VStack } from "web/react/emo/v-stack";
import { gettext } from "web/script/modules/django-i18n";

interface StorefrontInfoProps {
    description?: string | null;
    dateAdded: string | null;
    shipsToCountry: string | null;
    bestShippingOption: string | null;
    isCheckout?: boolean;
    isOfficialStore?: boolean;
}

export function StorefrontInfo({
    description,
    dateAdded,
    shipsToCountry,
    bestShippingOption,
    isCheckout = false,
    isOfficialStore = false,
}: StorefrontInfoProps): React.ReactElement {
    const hasLabels = isCheckout || isOfficialStore;

    return (
        <VStack spacing="md">
            {(description || hasLabels) && (
                <VStack spacing="sm">
                    <StorefrontDescription description={description} />
                    {hasLabels && (
                        <HStack spacing="xxs">
                            {isCheckout && <Sticker name="lystShopPartner" />}
                            {isOfficialStore && <Sticker name="officialStore" />}
                        </HStack>
                    )}
                </VStack>
            )}
            <VStack spacing="sm">
                <StorefrontInfoList
                    dateAdded={dateAdded}
                    shipsToCountry={shipsToCountry}
                    bestShippingOption={bestShippingOption}
                />
                {isCheckout && (
                    <Text textStyle="body-xs" color="secondary">
                        {gettext("storefront.verified.disclaimer")}
                    </Text>
                )}
            </VStack>
        </VStack>
    );
}
